module.exports = __webpack_public_path__ + "assets/icon_back_arrow.c503df6d.svg";